module.exports = {
	"shared.crew.original-music-composer": "Oryginalna Muzyka/Kompozytor",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Publicysta",
	"share-overlay.share": "Udostępnij to Wideo",
	"shared.crew.associate-producer": "Współproducer",
	"shared.crew.assistant-editor": "Asystent Edytora",
	"overlay.buy-from": "Kup od {price}",
	"shared.crew.agent": "Agent",
	"shared.crew.additional-photography": "Dodatkowa Fotografia",
	"shared.crew.sound-editor": "Edytor Dźwięku",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Fryzjer",
	"shared.crew.makeup-effects": "Charakteryzacja",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Asystent Produkcji",
	"shared.crew.executive-producer": "Producent Wykonawczy",
	"shared.crew.costumer": "Kostiumy",
	"info-overlay.cast": "obsada",
	"shared.crew.stunt-coordinator": "Koordynator Kaskaderów",
	"shared.crew.academic-advisor": "Doradca Akademicki",
	"shared.crew.swing-gang": "Swing Gang",
	"shared.crew.best-boy": "Best Boy",
	"actions.purchased": "Jesteś właścicielem tego filmu",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Dekorator",
	"shared.crew.adaptation": "Adaptacja",
	"shared.crew.school-administrator": "Administrator Szkolny",
	"shared.crew.cable-person": "Kierownik Kabli",
	"shared.crew.digital-effects": "Efekty Specjalne",
	"actions.rent": "Wypożyczenie {price}",
	"info-overlay.created-by": "Autor: {author}",
	"social-share.twitter": "Ogladaj \"{tytuł}\" na {Url}",
	"shared.crew.production-designer": "Scenograf",
	"info-overlay.crew": "Obsada",
	"shared.crew.producer": "Producent",
	"shared.crew.2nd-unit-dir-of-photography": "II Reżyser Fotografii",
	"shared.crew.special-effects": "Efekty Specjalne",
	"actions.rented": "Wypożyczony do {date}",
	"shared.crew.boom-operator": "Mikrofoniarz",
	"shared.crew.story": "Fabuła",
	"shared.crew.script-supervisor": "Nadzorca Scenariusza",
	"shared.crew.director": "Reżyser",
	"shared.crew.choreographer": "Choreograf",
	"shared.crew.production-manager": "Kierownik Produkcji",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Lead Person",
	"shared.crew.location-manager": "Menedżer Lokalizacji",
	"shared.crew.costume-designer": "Kostiumograf",
	"fullscreen.exit": "Wyjdź z pełnego ekranu",
	"shared.crew.technical-advisor": "Doradca Techniczny",
	"shared.crew.editor": "Edytor",
	"shared.crew.additional-grip": "Dodatkowe Info",
	"actions.buy": "Kupno {price}",
	"shared.crew.assistant-camera": "Asystent Operatora",
	"shared.crew.writer": "Pisarz",
	"social-share.pinterest": "{tytuł} - {opis}",
	"shared.crew.collaborating-director": "Reżyser Współpracujący",
	"fullscreen.enter": "Pełen ekran",
	"shared.crew.animal-trainer": "Trener Zwierząt",
	"shared.crew.assistant-art-director": "Asystent Dyrektora Artystycznego",
	"shared.crew.key-grip": "Kierownik Oświetlenia",
	"social-button.copy": "Kopiuj",
	"shared.crew.makeup-artist": "Wizażysta",
	"overlay.source-error": "Nie można odtworzyć wideo",
	"social-button.link": "Link",
	"actions.buy-from": "Kup od {price}",
	"shared.crew.art-director": "Dyrektor Artystyczny",
	"shared.crew.production-coordinator": "Koordynator Produkcji",
	"shared.crew.co-director": "Współreżyser",
	"shared.crew.co-producer": "Koproducent",
	"shared.crew.video-operator": "Operator Wideo",
	"shared.crew.camera-operator": "Operator Kamery",
	"shared.crew.co-writer": "Współscenarzysta",
	"shared.crew.set-designer": "Scenograf",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Mistrz Wynajmu",
	"shared.crew.cinematographer-dp": "Operator/DP",
	"shared.crew.grip": "Oświetleniowiec",
	"social-share.tumblr": "{tytuł} - {Url}",
	"shared.crew.sound-mixer": "Technik Dźwięku",
	"quality.label": "Jakość",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Mistrz Oświetlenia",
	"shared.crew.assistant-director": "Asystent Reżysera",
	"actions.subscribe": "Subskrypcja {price}/miesiąc",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Animator",
	"shared.crew.dolly-grip": "Dolly Grip",
	"shared.crew.manager": "Menedżer",
	"shared.crew.2nd-assistant-director": "II Asystent Reżysera",
	"shared.crew.author-of-adapted-material": "Autor Adaptacji Materiałów"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_pl.json
// module id = 2795
// module chunks = 66